import {
  createAsyncThunk,
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { AppState } from '@/store/store';
import { httpGet, httpPut } from '@/utils/helpers/httpHelperPartner';
import CONFIG from 'config';

export type RequestType = {
  id: string;
  price: string;
  status: {
    value: string;
    reason: {
      value: string;
      comment: string;
    };
  };
  campaignStartDate: string;
  campaignEndDate: string;
  merchantDetail: {
    city: string;
    phone: string;
    email: string;
    name: string;
  };
  subCategoryName: string;
  subCategory: number;
  discountedPrice: number;
  name: string;
  createdAt: string;
};

export type StatusAndReason = {
  text: string;
  value: string;
};

export type RequestStatusesType = {
  statuses: StatusAndReason[];
  reasons: StatusAndReason[];
};

export const fetchRequests: any = createAsyncThunk(
  'requests/fetchRequests',
  async (arg, { getState }) => {
    const { requests }: any = getState();
    const { data } = await httpGet(
      // `${CONFIG.ENDPOINTS.partnerRequests}?page=${requests.page}&limit=${requests.numPerPage}`
      `${CONFIG.ENDPOINTS.partnerRequests}?page=${requests.page}&limit=${requests.numPerPage}`
    );
    return data;
  }
);

export const fetchStatuses: any = createAsyncThunk(
  'requests/fetchStatuses',
  async () => {
    const { data } = await httpGet(`${CONFIG.ENDPOINTS.statuses}`);
    return data;
  }
);

export const updateStatus: any = createAsyncThunk(
  'requests/updateStatus',
  async (requestAndStatus: any, { dispatch }) => {
    let body;
    if (requestAndStatus.fromModal) {
      body = {
        reason: {
          comment: requestAndStatus.status.comment
            ? requestAndStatus.status.comment
            : '',
          value: requestAndStatus.status.selectedReason.value,
        },
        value: 'not_bought',
      };
    } else {
      body = {
        reason: { comment: '', value: '' },
        value: requestAndStatus.status.value,
      };
    }
    const { data } = await httpPut(
      `${CONFIG.ENDPOINTS.updateStatus}${requestAndStatus.id}/status`,
      body
    );
    dispatch(
      updateRequest({
        id: requestAndStatus.id,
        changes: {
          status: requestAndStatus.fromModal
            ? {
                text: 'Satın alınmadı',
                value: 'not_bought',
                reason: {
                  value: requestAndStatus.status.selectedReason.value,
                  comment: requestAndStatus.status.comment
                    ? requestAndStatus.status.comment
                    : '',
                },
              }
            : requestAndStatus.status,
        },
      })
    );

    return data;
    // return;
  }
);

const requestAdapter = createEntityAdapter<RequestType>({
  selectId: (request) => request.id,
});

export const requestSlice = createSlice({
  name: 'requests',
  initialState: requestAdapter.getInitialState({
    loading: true,
    error: false,
    page: 1,
    numPerPage: 10,
    sort: 'createdAt',
    direction: 'desc',
    totalCount: null,
    filter: 'all',
    requests: null as RequestType[],
    requestStatuses: null as RequestStatusesType,
  }),
  reducers: {
    updateRequest: requestAdapter.updateOne,

    changePage: (state, action) => {
      state.page = action.payload;
    },
    changeNumPerPage: (state, action) => {
      state.numPerPage = action.payload;
    },
    changeSort: (state, action) => {
      state.sort =
        action.payload.direction === 'none'
          ? ''
          : `${action.payload.name}_${action.payload.direction}`;
    },
    changeAllFilters: (state, action) => {
      state.sort = action.payload.sort;
      state.page = action.payload.page;
      state.numPerPage = action.payload.perPage;
    },
  },
  extraReducers: {
    [fetchRequests.pending](state) {
      state.loading = true;
    },
    [fetchRequests.fulfilled](state, { payload }) {
      requestAdapter.setAll(state, payload.data.items);
      state.totalCount = payload.data.totalCount;
      state.loading = false;
    },
    [fetchRequests.rejected](state) {
      state.loading = false;
      state.error = true;
    },
    [fetchStatuses.pending](state) {
      state.loading = true;
    },
    [fetchStatuses.fulfilled](state, { payload }) {
      state.requestStatuses = payload.data;
      state.loading = false;
    },
    [fetchStatuses.rejected](state) {
      state.loading = false;
      state.error = true;
    },
  },
});

export const { updateRequest, changePage, changeNumPerPage, changeAllFilters } =
  requestSlice.actions;
export const requestSelectors = requestAdapter.getSelectors<AppState>(
  (state) => state.requests
);
requestAdapter.getSelectors<AppState>((state) => state.requests);

// export const { selectAll, selectById, selectIds, selectEntities } = companySelectors;

export default requestSlice.reducer;
